import { Suspense } from 'react'
import { Alert, AlertTitle, Button } from '@mui/material'
import { Navigate, Outlet } from 'react-router-dom'
import { FullScreenLoading, PageContainer } from '../components'
import { useAuth } from '../hooks'
import { StyledPrivateLayout } from './styles'

export function PrivateLayout() {
  const { loading, error, user, setLoading } = useAuth()

  const reloadPage = () => {
    setLoading(true)
    window.location.reload()
  }

  if (loading) return <FullScreenLoading />

  if (error)
    return (
      <Suspense fallback={<FullScreenLoading />}>
        <StyledPrivateLayout>
          <PageContainer>
            <Alert severity="error">
              <AlertTitle className="font-bold">An error occurred</AlertTitle>
              <div className="my-2 mb-4">{error}</div>

              <div className="text-secondary w-max ml-auto">
                <Button variant="outlined" color="inherit" onClick={reloadPage}>
                  Reload page
                </Button>
              </div>
            </Alert>
          </PageContainer>
        </StyledPrivateLayout>
      </Suspense>
    )

  if (!user || !user?.token) return <Navigate to="/login" />

  if (user.type?.toUpperCase() === 'ADMIN')
    return <Navigate to={`/${user.type.toLowerCase()}`} />

  return (
    <Suspense fallback={<FullScreenLoading />}>
      <StyledPrivateLayout className="!flex-row !justify-between">
        <main className="flex-1 h-screen overflow-auto">
          <PageContainer className="min-h-[90vh] pt-8">
            <Outlet />
          </PageContainer>
        </main>
      </StyledPrivateLayout>
    </Suspense>
  )
}
